import {initPaypalConnect} from "../Util/queries";
import {contructPaypalApprovalLink} from "../Factory/factory";
import { PAYPAL_APPROVAL_LINK } from "../Reducers/paypalApprovalReducer";

export const createPaypalConnection = () => async dispatch => {
    try {
        dispatch({
            type: PAYPAL_APPROVAL_LINK,
            payload: null,
        });
        const response = await initPaypalConnect();
        const paypalApprovalLink = contructPaypalApprovalLink(response.data);
        dispatch({
            type: PAYPAL_APPROVAL_LINK,
            payload: paypalApprovalLink
        });
    } catch (e) {
        console.error(e);
    }
}
